/* Vue  ++++++++++++++++++++++++++++++++++++++++++*/
import axios from 'axios';
import Slider from '@vueform/slider';

const Vue = require('vue');

const {
    ref, onMounted, computed,
} = Vue;
const App = {
    components: {
        Slider,
    },
    setup() {
        const houses = ref([]);
        const housesHasRooms = computed(() => houses.value.filter(
            (house) => house.acf.rooms >= roomsValue.value[0] && house.acf.rooms <= roomsValue.value[1]
        ));
        const filteredHouses = computed(() => houses.value.filter(
            (house) => house.acf.squareMeters >= squareMetersValue.value[0]
                    && house.acf.squareMeters <= squareMetersValue.value[1]
        ).filter((house) => {
            if (!housesHasRooms.value.length) return true;

            return house.acf.rooms >= roomsValue.value[0] && house.acf.rooms <= roomsValue.value[1];
        }).filter(
            (house) => {
                if (!currentType.value) return true;

                let typeCheck = false;
                Array.from(house.housestypeTax).forEach((type) => {
                    if (type.term_id === currentType.value) {
                        typeCheck = true;
                    }
                });

                return typeCheck;
            }
        ));
        const page = ref(1);
        const perPage = ref(6);
        const housesList = computed(() => filteredHouses.value.slice(0, perPage.value * page.value));
        const squareMetersValue = ref([1, 9999]);
        const squareMetersMaxMin = ref([1, 999]);
        const roomsValue = ref([1, 99]);
        const roomsMaxMin = ref([1, 99]);
        const allTypes = ref([]);
        const currentType = ref(null);
        const ready = ref(false);

        onMounted(async() => {
            await getHouses();

            ready.value = true;

            roomsMaxMin.value = houses.value.reduce((acc, value) => {
                if (!acc) {
                    return [Math.floor(+value.acf.rooms),
                        Math.ceil(+value.acf.rooms)];
                }

                return [acc[0] < +value.acf.rooms ? acc[0] : Math.floor(+value.acf.rooms),
                    acc[1] > +value.acf.rooms ? acc[1] : Math.ceil(+value.acf.rooms)];
            }, null);

            squareMetersMaxMin.value = houses.value.reduce((acc, value) => {
                if (!acc) {
                    return [Math.floor(+value.acf.squareMeters / 10) * 10,
                        Math.ceil(+value.acf.squareMeters / 10) * 10];
                }

                return [acc[0] < +value.acf.squareMeters ? acc[0] : Math.floor(+value.acf.squareMeters / 10) * 10,
                    acc[1] > +value.acf.squareMeters ? acc[1] : Math.ceil(+value.acf.squareMeters / 10) * 10];
            }, null);

            const tempTypes = [];
            for (let houseI = 0; houseI < houses.value.length; houseI++) {
                const house = houses.value[houseI];

                for (let typeI = 0; typeI < house.housestypeTax.length; typeI++) {
                    const type = house.housestypeTax[typeI];
                    if (!tempTypes.includes(type.term_id)) {
                        tempTypes.push(type.term_id);
                        allTypes.value.push(type);
                    }
                }
            }
        });

        async function getHouses() {
            let currentLang = '';
            // eslint-disable-next-line no-undef
            if (wp_urls.currentLang && wp_urls.currentLang !== 'de') {
                // eslint-disable-next-line no-undef
                currentLang = `/${wp_urls.currentLang}`;
            }

            await axios.get(`${window.location.origin}${currentLang}/wp-json/wp/v2/houses`, {
                params: {
                    _embed: true,
                    _fields: 'title, id, thumb, permalink, acf, housestypeTax, primarymagazinecat',
                    orderby: 'menu_order',
                    order: 'asc',
                    per_page: 9999,
                }
            }).then((response) => {
                houses.value = response.data;
            }).catch((error) => {
                console.log(error.toJSON()); // eslint-disable-line no-console
            });
        }

        return {
            houses,
            housesHasRooms,
            housesList,
            filteredHouses,
            page,
            perPage,
            squareMetersValue,
            squareMetersMaxMin,
            roomsValue,
            roomsMaxMin,
            allTypes,
            currentType,
            ready,
        };
    }
};

Vue.createApp(App).mount('#modelhousesFilter');
